import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { userActions } from '@akademiasaas/shared';
import { useAppDispatch } from '~/initializeStore';
import AuthCard, { AuthHeading } from '../../layout/AuthCard';
import EmailForm from '../../form/EmailForm';
import SentResult from '../../form/SentResult';

/**
 * Adres z „Nie pamiętasz hasła?” przychodzi w ścieżce zakodowany (`jan%40firma.pl`) — history dekoduje
 * ścieżkę przez decodeURI, który zostawia %40 i %2B, a react-router nie dekoduje parametrów.
 */
export function decodeEmailParam(value: string | undefined): string {
  if (!value) return '';
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

export const ForgotPassword: FunctionComponent = () => {
  const { t } = useTranslation(['auth']);
  const dispatch = useAppDispatch();
  const params = useParams<{ email?: string }>();
  const [email, setEmail] = useState(() => decodeEmailParam(params.email));
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const send = async (address: string) => {
    await dispatch(userActions.sendPasswordResetEmail(address, window.location.origin));
  };

  const onSubmit = async (address: string) => {
    setBusy(true);
    setEmail(address);
    await send(address);
    setBusy(false);
    setSent(true);
  };

  return (
    <AuthCard footer={<Link to="/auth/login">{t('auth:screens.sent.back')}</Link>}>
      {sent ? (
        <SentResult
          email={email}
          textKey="auth:screens.forgot.sentText"
          resendLabel={t('auth:screens.forgot.resend')}
          onResend={() => send(email)}
          onFixAddress={() => setSent(false)}
        />
      ) : (
        <>
          <AuthHeading
            title={t('auth:screens.forgot.title')}
            lead={t('auth:screens.forgot.lead')}
          />
          <EmailForm
            name="forgotPassword"
            initialEmail={email}
            submitLabel={t('auth:screens.forgot.submit')}
            busyLabel={t('auth:screens.forgot.busy')}
            busy={busy}
            onSubmit={onSubmit}
          />
        </>
      )}
    </AuthCard>
  );
};
